import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';

import './form-item-business-lending-vaf-cmb.component.scss';

export class FormItemBusinessLendingVafCmb extends Base {
	// form
	form: HTMLFormElement;
	steps: HTMLFormElement[];

	// form sections
	formLoader: Element;
	formFields: Element;
	formThankyou: Element;
	timeout: any;
	customHeading: HTMLFormElement;

	// inputs
	entityType: HTMLFormElement;
	southAfricanIdField: HTMLFormElement;
	businessFields: HTMLFormElement[];
	jointFields: HTMLFormElement[];
	applicantAdd: HTMLFormElement;
	applicantRem: HTMLFormElement[];

	// buttons
	buttonSubmit: Element;
	stepButtons: Element[];

	// wizard count
	wizardCount: Element;
	bulletContainer: Element;
	totalSteps: Element;

	// hidden
	hidLeadId: any;
	hidProduct: any;
	hidCallMeBackModalId: any;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.formLoader = this.element.querySelector(".form__loader--container");
		this.formFields = this.element.querySelector(".form__fields--container");
		this.formThankyou = this.element.querySelector(".form__thankyou--container");
		this.customHeading = this.element.querySelector(".customHeading");

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.steps = Array.from(this.element.querySelectorAll(".business-lending-vaf-cmb__steps--step[data-step]"));
		this.buttonSubmit = this.element.querySelector('.js_step-submit-button');
		this.stepButtons = Array.from(this.element.querySelectorAll(".js_step-button"));

		this.hidLeadId = this.form.querySelector('input[name=leadId]');
		this.hidProduct = this.form.querySelector('input[name=product]');

		this.entityType = this.element.querySelector(".js-apply-now-entity-type");
		this.businessFields = Array.from(this.element.querySelectorAll(".js-business-apply-now-vaf-cmb"));
		this.southAfricanIdField = this.element.querySelector('.js-hs-apply-now-vissible-id');

		this.wizardCount = this.element.querySelector(".business-lending-vaf-cmb__counter--count");
		this.bulletContainer = this.element.querySelector(".business-lending-vaf-cmb__bullets");

		this.totalSteps = this.element.querySelector('input[name="total-steps"]');
		this.totalSteps.nodeValue = this.steps.length.toString();
		this.showStep(1);

		if (this.entityType) {
			this.updateForm(this.entityType.value);
		}
	}

	bindEvents() {

		if (this.buttonSubmit) {
			this.buttonSubmit.addEventListener('click', (event) => {
				const _button = event.target as HTMLFormElement;
				const _form = _button.closest('form') as HTMLFormElement;
				const formFields: any = _form.querySelectorAll('input, select');
				this.validationService.validate(formFields);
				const valid = Array.from(_form.querySelectorAll(".form__group--error"));
				if (valid.length == 0) {
					this.submitForm(_form);
				}
			});
		}

		if (this.stepButtons.length) {
			this.stepButtons.map((item) => item.addEventListener('click', (event) => {
				const _event: any = event.currentTarget;
				const _currentStep = _event.closest(".business-lending-vaf-cmb__steps--step");
				if (!_currentStep.classList.contains("business-lending-vaf-cmb__steps--hidden")) {
					const formFields: any = _currentStep.querySelectorAll('input, select, textarea');
					this.validationService.validate(formFields);
					const valid = Array.from(_currentStep.querySelectorAll(".form__group--error"));
					if (valid.length == 0) {
						this.showNextStep(event);
					}
				}
			}));
		}

		if (this.entityType) {
			this.entityType.addEventListener('change', (event) => {
				this.updateForm(this.entityType.value);
			});
		}

		// This adds slashes to the business registration number
		let businessReg = this.element.querySelector(".js-business-apply-now-vaf-cmb");

		if (businessReg) {

			businessReg.addEventListener('input', (event: any) => {
				if ((event.inputType != "deleteContentBackward") && (event.inputType != "deleteContentForward")) {
					let reg = event.target.value;
					event.target.value = this.formatBusinessReg(reg);
				}
			});

			businessReg.addEventListener('blur', (event: any) => {
				let reg = event.target.value;
				event.target.value = this.formatExpression(reg);
			});
		}

		// Reset the form
		this.form.addEventListener('custom_form_reset_event', (e) => {
			this.showStep(1);

			// This will reset step 2
			if (this.entityType) {
				this.updateForm(this.entityType.value);
			}

		}, false);
	}

	formatBusinessReg(event) {
		const _stringLength: number = parseFloat(event.length);
		const _newLength: number = (_stringLength - 1);
		const _check = event.substring(_newLength);
		const reg = new RegExp('^[0-9]+$');
		if (reg.test(_check)) {
			if (event.length == 4) {
				event = event += "/";
			} else if (event.length == 11) {
				event = event += "/";
			} else if (event.length > 14) {
				event = event.substring(0, 14);
			}
		}
		else {
			return event.substring(0, _newLength);
		}

		return event;
	}

	formatExpression(inputText: string) {
		let _check = inputText.split('/');
		if (inputText.length >= 12) {
			let _firstcharacters = inputText.substring(0, 4);
			let _secondCharacters = inputText.substring(5, 11);
			let _thirdCharacters = inputText.substring(12, 14);
			return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
		} else if (_check.length > 1) {
			let _valid1 = false;
			let _valid2 = false;
			let _valid3 = false;
			if (_check.length == 3) {
				const _seg1 = new RegExp('^[0-9]{4}$');
				const _seg2 = new RegExp('^[0-9]{6}$');
				const _seg3 = new RegExp('^[0-9]{2}$');
				if (_seg1.test(_check[0])) {
					_valid1 = true;
				}
				if (_seg2.test(_check[1])) {
					_valid2 = true;
				}
				if (_seg3.test(_check[2])) {
					_valid3 = true;
				}
				if (_valid1 && _valid2 && _valid3) {
					return inputText;
				} else {
					return '';
				}
			} else {
				return '';
			}
		}
		return '';
	}

	showStep(stepId) {
		const _currentstep = this.element.querySelector("[data-step='" + stepId + "']");
		const _heading: any = _currentstep.getAttribute("data-heading");
		if (_heading) {
			const _h3Heading = this.customHeading.querySelector("h3");
			_h3Heading.innerHTML = _heading;
		}
		const _listItems = document.createElement('ul');
		_listItems.classList.add("business-lending-vaf-cmb__bullets-container");
		if (this.steps) {
			this.steps.forEach((element, index) => {
				const _step = element.getAttribute("data-step");
				const _listItem = document.createElement('li');
				if ((parseFloat(_step) == stepId)) {
					element.classList.remove("business-lending-vaf-cmb__steps--hidden");
					_listItem.classList.add("business-lending-vaf-cmb__bullets-container--bullet", "business-lending-vaf-cmb__bullets-container--bullet--active");
				} else {
					element.classList.add("business-lending-vaf-cmb__steps--hidden");
					_listItem.classList.add("business-lending-vaf-cmb__bullets-container--bullet");
				}
				_listItem.innerHTML = "&bull;";

				_listItems.appendChild(_listItem);

				if (index < (this.steps.length - 1)) {
					const _listPipe = document.createElement('li');
					_listPipe.classList.add("business-lending-vaf-cmb__bullets-container--bullet", "business-lending-vaf-cmb__bullets-container--bullet--link");
					_listPipe.innerHTML = "&nbsp;";
					_listItems.appendChild(_listPipe);
				}
			});
		}
		if (this.wizardCount) {
			this.wizardCount.innerHTML = stepId + "/" + parseFloat(this.totalSteps.getAttribute('value'));
		}
		this.bulletContainer.innerHTML = "";
		this.bulletContainer.appendChild(_listItems);
		//this.updateForm(this.applicationType.value);
	}

	showNextStep(event) {
		const _target = event.currentTarget;
		const _currentStep = _target.closest("[data-step]");
		const _nextStep = _currentStep.getAttribute("data-step");
		if (this.wizardCount) {
			this.wizardCount.innerHTML = parseFloat(_nextStep) + 1 + "/" + parseFloat(this.totalSteps.getAttribute('value'));
		}
		this.showStep(parseFloat(_nextStep) + 1);
	}

	updateForm(type) {
		if (this.southAfricanIdField) {
			const _group = this.southAfricanIdField.closest(".form__group")
			if (type !== 'SOLE') {
				this.southAfricanIdField.classList.remove("form__input--required");
				_group.classList.add('form__group--hidden');

			} else {
				this.southAfricanIdField.classList.add("form__input--required");
				_group.classList.remove("form__group--hidden");
			}
		}

		if (this.businessFields) {
			this.businessFields.forEach(elem => {
				const _group = elem.closest(".form__group ");
				if (type !== 'SOLE') {
					elem.classList.add("form__input--required");
					_group.classList.remove("form__group--hidden");

				} else {
					elem.classList.remove("form__input--required");
					_group.classList.add('form__group--hidden');
				}
			});
		}
	}

	createElement(type, inputName, label, modifiers) {
		const _div = document.createElement('div');
		_div.classList.add("form__group");

		let _input;

		if (type == 'text') {
			const _label = document.createElement("label");
			_label.classList.add("form__label");
			_label.innerText = label;

			_input = document.createElement("input")
			_input.type = type;
			_input.name = inputName;
			_input.classList.add("form__input");
			_input.classList.add(...modifiers);

			_div.appendChild(_label);
			_div.appendChild(_input);
		}

		return _div;
	}

	createTextField(object) {
		let _group = document.createElement('div');
		_group.classList.add("form__group");
		_group.setAttribute("data-question", object.questionCode);

		let _wrapper = document.createElement('div');
		_wrapper.classList.add('apply-now__radio');

		let _label = document.createElement("label");
		_label.classList.add("form__label");
		_label.innerText = object.label;

		let _textBox = document.createElement("input");
		_textBox.classList.add("form__input", "form__input--required");
		_textBox.setAttribute("type", "text");
		_textBox.setAttribute("name", object.name);
		_textBox.setAttribute("value", "");
		// _textBox.setAttribute("placeholder", object.placeholder);

		_label.appendChild(_textBox);
		_wrapper.appendChild(_label);
		_group.appendChild(_wrapper);

		return _group;
	}

	createButton() {
		let _wrapper = document.createElement('div');
		_wrapper.classList.add("apply-now__buttons");

		let _button = document.createElement("button");
		_button.classList.add("button", "button--medium", "apply-now__button", "js_survey-button");
		_button.setAttribute("type", "button");
		_button.setAttribute("data-id", "link_content_survey button");
		_button.setAttribute("data-text", "home services | apply now | survey submit button click");
		_button.innerText = "Submit";

		_wrapper.appendChild(_button);

		return _wrapper;
	}

	submitForm(form: HTMLFormElement) {
		// success screens
		const loader = form.querySelector('.form__loader--container');
		const thankYou = form.querySelector('.form__thankyou--container');
		const success = form.querySelector('.form__success--container');
		const error = form.querySelector('.form__error--container');
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		let name = Array.from(form.querySelectorAll('.form__success-container__firstname'));


		let postData = '';

		let serviceType: any = form.querySelector("input[name=service-type]");
		if (serviceType) {
			postData += "&service-type=" + serviceType.value;
		}
		let _loanAmount: any = this.form.querySelector('input[name=loan-amount]');
		if (_loanAmount) {
			postData += "&how-much-do-you-need=" + _loanAmount.value;
		}
		let _firstname: any = this.form.querySelector('input[name=first-name]');
		if (_firstname) {
			postData += "&firstname=" + _firstname.value;
		}
		let _surname: any = this.form.querySelector('input[name=last-name]');
		if (_surname) {
			postData += "&surname=" + _surname.value;
		}
		let _contactNumber: any = this.form.querySelector('input[name=phone-number]');
		if (_contactNumber) {
			postData += "&contactNo=" + _contactNumber.value;
		}
		let _alternativeContactNumber: any = this.form.querySelector('input[name=alternative-number]');
		if (_alternativeContactNumber) {
			postData += "&altContactNo=" + _alternativeContactNumber.value;
		}
		let _idNumber: any = this.form.querySelector('input[name=sa-identity-number]');
		if (_idNumber) {
			postData += "&saId=" + _idNumber.value;
		}
		let _businessAccountCurrentlyHeld: any = this.form.querySelector('select[name=business-account]');
		if (_businessAccountCurrentlyHeld) {
			postData += "&bankName=" + _businessAccountCurrentlyHeld.value;
		}
		let _accountNumber: any = this.form.querySelector('input[name=account-number]');
		if (_accountNumber) {
			postData += "&bankAccountNo=" + _accountNumber.value;
		}
		let _entityType: any = this.form.querySelector('select[name=entity-type]');
		if (_entityType) {
			postData += "&entityType=" + _entityType.value;
		}
		let _businessName: any = this.form.querySelector('input[name=business-name]');
		if (_businessName) {
			postData += "&businessName=" + _businessName.value;
		}
		let _businessRegNumber: any = this.form.querySelector('input[name=business-reg-number]');
		if (_businessRegNumber) {
			postData += "&business-registration=" + _businessRegNumber.value;
		}
		let _email: any = this.form.querySelector('input[name=email-address]');
		if (_email) {
			postData += "&emailAddress=" + _email.value;
		}
		let _existingQuote: any = this.form.querySelector('select[name=existing-quote]');
		if (_existingQuote) {
			postData += "&hasExistingVehicleQuote=" + _existingQuote.value;
		}
		let _businessDo: any = this.form.querySelector('input[name=business-do]');
		if (_businessDo) {
			postData += "&business-description=" + _businessDo.value;
		}
		let _purpose: any = this.form.querySelector('textarea[name=purpose]');
		if (_purpose) {
			postData += "&purpose=" + _purpose.value;
		}
		let _turnOver: any = this.form.querySelector('input[name=turnover-tax]');
		if (_turnOver) {
			postData += "&monthlyTurnOver=" + _turnOver.value;
		}
		let description: any = form.querySelector("input[name=description]");
		if (description) {
			postData += "&description=" + description.value;
		}
		let email: any = form.querySelector("input[name=email]");
		if (email) {
			postData += "&email=" + email.value;
		}
		let recipient: any = form.querySelector("input[name=recipient]");
		if (recipient) {
			postData += "&recipient=" + recipient.value;
		}
		let subject: any = form.querySelector("input[name=subject]");
		if (subject) {
			postData += "&subject=" + subject.value;
		}
		let product: any = form.querySelector("input[name=product]");
		if (product) {
			postData += "&product=" + product.value;
		}
		let redirect: any = form.querySelector("input[name=redirect]");
		if (redirect) {
			postData += "&redirect=" + redirect.value;
		}

		// loader + hide form
		this.formLoader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = + "/services/SubmitGenericForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			this.formLoader.classList.remove('active');
			if (response.data === 'invalid') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				this.formThankyou.classList.add('active');
				error.classList.add('active');
			} else {
				analyticsService.dtmFormComplete('complete', response.code);
				this.formThankyou.classList.add('active');
				success.classList.add('active');
			}
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			this.formLoader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-business-lending-vaf-cmb/form-item-business-lending-vaf-cmb.component.ts